/**
 * Get all different experiments from spectra data.
 *
 * @param {Spectra} spectraData
 */
export function getExperiments(spectraData) {
    if (!spectraData)
        return {};
    const experiments = {};
    for (const spectrum of spectraData) {
        if (spectrum.info.isFid)
            continue;
        if (!experiments[`${spectrum.info.dimension}D`]) {
            experiments[`${spectrum.info.dimension}D`] = {};
        }
        const experiment = spectrum.info.experiment;
        if (!experiments[`${spectrum.info.dimension}D`][`${experiment}`]) {
            experiments[`${spectrum.info.dimension}D`][`${experiment}`] = [];
        }
        experiments[`${spectrum.info.dimension}D`][`${experiment}`].push(spectrum);
    }
    return experiments;
}
//# sourceMappingURL=getExperiments.js.map